export enum MdEnableStatusEnum {
    DISABLE,
    ENABLE
}

export enum MenuTypeEnum {
    DEFAULT = 'default', // 默认
    BOOKING = 'booking', // 预约
    TAKEOUT = 'takeout', // 外带
}


//餐别分类
export enum IMealTypeEnum {
    //早餐
    BREAKFAST = "breakfast",
    //中餐
    LUNCH = "lunch",
    //晚餐
    DINNER = "dinner"
}

export const IMealTypeOptions = [
    { label: "早餐", value: IMealTypeEnum.BREAKFAST },
    { label: "中餐", value: IMealTypeEnum.LUNCH },
    { label: "晚餐", value: IMealTypeEnum.DINNER },
]
export const IMealTypeObj: any = {
    breakfast: "早餐",
    lunch: "中餐",
    dinner: "晚餐",
}
export enum FoodCategory {
    cold = 'cold', // 凉菜
    hot = 'hot', // 热菜
    staple = 'staple', // 主食
    material = 'material', // 原材料
    other = 'other', // 其他
}
export const IFoodCategoryOotions = [
    { label: "凉菜", value: FoodCategory.cold },
    { label: "热菜", value: FoodCategory.hot },
    { label: "主食", value: FoodCategory.staple },
    { label: "原材料", value: FoodCategory.material },
    { label: "其它", value: FoodCategory.other },
]

export const IFoodCategoryOotion = [
    { label: "凉菜", value: FoodCategory.cold },
    { label: "热菜", value: FoodCategory.hot },
    { label: "主食", value: FoodCategory.staple },
    { label: "其它", value: FoodCategory.other },
]